import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function UpgradeToBroker() {
  const { token, setUser } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ agency_name: "", pan_number: "", gst_number: "", business_address: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await fetch("/api/auth/upgrade-to-broker", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(form),
    });
    const d = await r.json();
    setBusy(false);
    if (!r.ok) return toast.error(d.detail || "Upgrade failed.");
    toast.success("Upgraded to Broker Admin! Please log in again.");
    setTimeout(() => nav("/login"), 1500);
  };

  return (
    <div className="max-w-lg mx-auto py-10 px-4">
      <h1 className="text-2xl font-bold font-display mb-1">Upgrade to Broker Admin</h1>
      <p className="text-gray-500 text-sm mb-6">One-time upgrade. All your data carries over.</p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm font-medium">Agency / Business Name</label>
          <input required value={form.agency_name} onChange={set("agency_name")} placeholder="Reddy Realty" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500" />
        </div>
        <div>
          <label className="text-sm font-medium">Business PAN</label>
          <input required value={form.pan_number} onChange={set("pan_number")} placeholder="ABCDE1234F" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500" />
        </div>
        <div>
          <label className="text-sm font-medium">GST Number <span className="text-gray-400">(optional)</span></label>
          <input value={form.gst_number} onChange={set("gst_number")} placeholder="22ABCDE1234F1Z5" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500" />
        </div>
        <div>
          <label className="text-sm font-medium">Business Address</label>
          <input required value={form.business_address} onChange={set("business_address")} placeholder="Mumbai, Maharashtra" className="mt-1 w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500" />
        </div>
        <div className="pt-2 bg-amber-50 border border-amber-200 rounded-lg p-3">
          <p className="text-xs text-amber-700">This is a permanent upgrade. You cannot downgrade back to Agent. One PAN per business only.</p>
        </div>
        <button disabled={busy} className="w-full h-12 bg-[#F97316] hover:bg-[#EA580C] text-white rounded-lg font-medium disabled:opacity-50">
          {busy ? "Upgrading…" : "Upgrade to Broker Admin"}
        </button>
      </form>
    </div>
  );
}